import { INTENT_PROJECT_HISTORY_COLUMN_ID } from "../constants";
import IntentProjectOperationsTableOperationCell from "./OperationCell";
import IntentProjectOperationsTableResourceTypeCell from "./ResourceTypeCell";
import IntentProjectOperationsTableResourceIdCell from "./ResourceIdCell";
import IntentProjectOperationsTableProviderCell from "./ProviderCell";
import IntentProjectOperationsTableStateCell from "./StateCell";
import IntentProjectOperationsTableStateReasonCell from "./StateReasonCell";
import IntentProjectOperationsTableSessionCell from "./SessionCell";
import IntentProjectOperationsTableCreatedAtCell from "./CreatedAtCell";
import IntentProjectOperationsTablePolicyResultCell from "./PolicyResultCell";
import IntentProjectOperationsTableRowActionsCell from "./RowActionsCell";

const INTENT_PROJECT_OPERATIONS_TABLE_CELLS = {
  [INTENT_PROJECT_HISTORY_COLUMN_ID.OPERATION]: IntentProjectOperationsTableOperationCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_TYPE]: IntentProjectOperationsTableResourceTypeCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.RESOURCE_ID]: IntentProjectOperationsTableResourceIdCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.PROVIDER]: IntentProjectOperationsTableProviderCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.STATE]: IntentProjectOperationsTableStateCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.STATE_REASON]: IntentProjectOperationsTableStateReasonCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.SESSION]: IntentProjectOperationsTableSessionCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.CREATED_AT]: IntentProjectOperationsTableCreatedAtCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.POLICY_RESULT]: IntentProjectOperationsTablePolicyResultCell,
  [INTENT_PROJECT_HISTORY_COLUMN_ID.ROW_ACTIONS]: IntentProjectOperationsTableRowActionsCell,
};

export default INTENT_PROJECT_OPERATIONS_TABLE_CELLS;
